import Image from '@atlaskit/image';
import tagsAnatomyLight from "../../../../../../packages/design-system/tag/constellation/tag/images/tags-anatomy-light.png";
import tagsAnatomyDark from "../../../../../../packages/design-system/tag/constellation/tag/images/tags-anatomy-dark.png";
import tagDo1Light from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-do-1-light.png";
import tagDo1Dark from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-do-1-dark.png";
import tagDont1Light from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-dont-1-light.png";
import tagDont1Dark from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-dont-1-dark.png";
import tagDo2Light from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-do-2-light.png";
import tagDont2Light from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-dont-2-light.png";
import tagDo2Dark from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-do-2-dark.png";
import tagDont2Dark from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-dont-2-dark.png";
import tagDo3Light from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-do-3-light.png";
import tagDont3Light from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-dont-3-light.png";
import tagDo3Dark from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-do-3-dark.png";
import tagDont3Dark from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-dont-3-dark.png";
import tagDo4Light from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-do-4-light.png";
import tagDont4Light from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-dont-4-light.png";
import tagDo4Dark from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-do-4-dark.png";
import tagDont4Dark from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-dont-4-dark.png";
import tagDo5Light from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-do-5-light.png";
import tagDont5Light from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-dont-5-light.png";
import tagDo5Dark from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-do-5-dark.png";
import tagDont5Dark from "../../../../../../packages/design-system/tag/constellation/tag/images/tag-dont-5-dark.png";
import * as React from 'react';
export default {
  Image,
  tagsAnatomyLight,
  tagsAnatomyDark,
  tagDo1Light,
  tagDo1Dark,
  tagDont1Light,
  tagDont1Dark,
  tagDo2Light,
  tagDont2Light,
  tagDo2Dark,
  tagDont2Dark,
  tagDo3Light,
  tagDont3Light,
  tagDo3Dark,
  tagDont3Dark,
  tagDo4Light,
  tagDont4Light,
  tagDo4Dark,
  tagDont4Dark,
  tagDo5Light,
  tagDont5Light,
  tagDo5Dark,
  tagDont5Dark,
  React
};